import { Box, IconSize, ModalBody, useModalState } from '@bechtel/gds';
import { FC, useEffect } from 'react';
import { AppSpinner, ErrorRetry } from '~/components/atoms';
import { useMessage } from '~/hooks';
import { ErrorInfoModal } from './error-info-modal';
import { QuestionModal } from './question-modal';
import { ModalStyled } from './styled';
import { MessageModalProps, MessageType } from './types';

const MessageModal: FC<MessageModalProps> = ({ messageKeys: errors, onSubmit, onClose, dismissIndex }) => {
  const { visible, close } = useModalState(true);
  const { messages, queryResult } = useMessage(errors);
  const { loading, error, refetch } = queryResult;
  const messageType: MessageType | undefined = messages && messages.length > 0 ? messages[0].messageType : undefined;

  useEffect(() => {
    // Once messsages are fetched close the parent message modal
    if (messages && messages.length > 0) {
      close();
    }
  }, [messages, close]);

  if (messages && messageType === MessageType.INFO)
    return <ErrorInfoModal messages={messages} messageType={MessageType.INFO} onClose={onClose} />;

  if (messages && messageType === MessageType.ERROR)
    return <ErrorInfoModal messages={messages} messageType={MessageType.ERROR} onClose={onClose} />;

  if (messages && messageType === MessageType.QUESTION && onSubmit)
    return <QuestionModal messages={messages} onSubmit={onSubmit} dismissIndex={dismissIndex} />;

  return (
    <ModalStyled visible={visible}>
      {/* @ts-ignore adjust in GDS component to take child as prop  */}
      <ModalBody
        css={`
          flex-direction: column;
        `}
      >
        {loading && (
          <Box flexGrow={{ sm: 1 }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
            <AppSpinner size={IconSize.MEDIUM} />
          </Box>
        )}
        {error && <ErrorRetry refetch={refetch} />}
      </ModalBody>
    </ModalStyled>
  );
};
export default MessageModal;
